/* eslint-disable  */
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components/default-table';
import { AlertAdapter, CommonCurrencyInput, CommonInput, RegularButton } from 'pg-ui-library';
import { BenefitSettingsType, DependentsSettings, IBenefit, IDependent } from 'src/interfaces';
import React, { useEffect, useState } from 'react';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import {
  BeneficiariesFormBottom,
  BeneficiariesListContainer,
  BeneficiariesListFooter,
  BeneficiariesListRightBottom,
  FormInputWrapper,
  SelectedBeneficiariesContainer,
} from './styles';
import { lifeBenefits } from '../../utils/life-benefits';

const columns: TableColumn<IDependent>[] = [
  {
    name: 'Name',
    selector: (row: IDependent) => row.firstName as unknown as '',
  },
  {
    name: 'Relationship',
    selector: (row: IDependent) => row.relationship as unknown as '',
  },
  {
    name: 'SSN',
    selector: (row: IDependent) => row.ssn as unknown as '',
  },
  {
    name: 'Zip Code',
    selector: (row: IDependent) => row.zipCode as unknown as '',
  },
  {
    name: 'Birth Date',
    selector: (row: IDependent) => row.birthDate as unknown as '',
  },
  {
    name: 'Email',
    selector: (row: IDependent) => row.email as unknown as '',
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

export const BeneficiariesForm: React.FC<{
  beneficiaries: IDependent[];
  // eslint-disable-next-line no-unused-vars
  onSubmit: (values: { personId: string; percentToPay: number; name: string }[]) => void;
  onRequestBack: () => void;
}> = ({ beneficiaries, onSubmit, onRequestBack }) => {
  const [totalBeneficiaries, setTotalBeneficiaries] = useState<number>(0);
  const { t } = useTranslation();

  const beneficiariesForm = beneficiaries.map(b => ({
    personId: b.personId as string,
    percentToPay: 0,
    name: b.firstName,
  }));

  const initialValues = {
    beneficiaries: beneficiariesForm,
  };

  const formik = useFormik<{ beneficiaries: { personId: string; percentToPay: number; name: string }[] }>({
    initialValues,
    onSubmit: data => {
      onSubmit(data.beneficiaries);
    },
  });

  return (
    <>
      <h4>Select your Beneficiary(ies).</h4>
      <SelectedBeneficiariesContainer>
        {beneficiaries.map((b, index) => (
          <>
            <FormInputWrapper style={{ display: 'flex' }}>
              <CommonInput label="Name" value={b.firstName} disabled readOnly style={{ width: '100%' }} />
              <div style={{ marginLeft: '5%' }}>
                <CommonInput label="Relationship" value={b.relationship} disabled readOnly style={{ width: '100%' }} />
              </div>
            </FormInputWrapper>
            <FormInputWrapper>
              <CommonCurrencyInput
                id="percent"
                label="Selected percent"
                name={`percent[${index}]`} // Use an array field name
                placeholder="Please enter a number"
                suffix="%"
                step={1}
                max={100}
                maxLength={3}
                allowDecimals={false}
                allowNegativeValue={false}
                value={formik.values.beneficiaries[index].percentToPay} // Use index to access the value
                onValueChange={val => {
                  setTotalBeneficiaries(
                    formik.values.beneficiaries.map(b => b.percentToPay).reduce((acc, cur) => acc + cur)
                  );
                  if (val) {
                    // eslint-disable-next-line no-restricted-globals
                    formik.setFieldValue(
                      `beneficiaries[${index}].percentToPay`,
                      Number(isNaN(parseInt(val)) ? 0 : parseInt(val))
                    );
                  } else {
                    formik.setFieldValue(`beneficiaries[${index}].percentToPay`, 0);
                  }
                }}
              />
            </FormInputWrapper>
          </>
        ))}
      </SelectedBeneficiariesContainer>
      {totalBeneficiaries !== 100 ? <p style={{ color: 'red' }}>{t('benefits.benefit.percentage')}</p> : ''}
      <BeneficiariesFormBottom>
        <BeneficiariesFormBottom>
          {onRequestBack && <RegularButton onClick={onRequestBack}>{t('global.button.back')}</RegularButton>}
        </BeneficiariesFormBottom>
        <BeneficiariesFormBottom>
          <RegularButton
            type="submit"
            onClick={() => formik.handleSubmit()}
            disabled={!formik.isValid || totalBeneficiaries !== 100}
          >
            {t('global.form.submit')}
          </RegularButton>
        </BeneficiariesFormBottom>
      </BeneficiariesFormBottom>
    </>
  );
};

const removeDuplicatedDependentsById = (filteredData: IDependent[]) => {
  let datas: IDependent[] = [];
  filteredData.forEach(singleFilteredData => {
    const currentKey =
      (singleFilteredData.personId as string) ||
      (singleFilteredData.id as string) ||
      `${singleFilteredData.firstName || ''}-${singleFilteredData.relationship || ''}-${singleFilteredData.ssn || ''}-${
        singleFilteredData.birthDate || ''
      }`;
    let valid = true;
    for (const data of datas) {
      const existingKey =
        (data.personId as string) ||
        (data.id as string) ||
        `${data.firstName || ''}-${data.relationship || ''}-${data.ssn || ''}-${data.birthDate || ''}`;
      if (existingKey === currentKey) {
        valid = false;
        break;
      }
    }
    if (valid) {
      datas.push(singleFilteredData);
    }
  });
  return datas;
};

export const BeneficiariesSettingsForm: React.FC<{
  benefit: IBenefit;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (benefit: IBenefit) => void;
  onRequestNewBeneficiarie?: () => void;
  onRequestBack?: () => void;
}> = ({ benefit, onSubmit, onRequestNewBeneficiarie, onRequestBack }) => {
  const { t } = useTranslation();
  const { data } = useTypedSelector(state => state.personalInfo);
  const [modalState, setModalState] = useState<'SELECTION' | 'FINISH'>('SELECTION');
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<IDependent[]>([]);
  const list = (data?.personalInfo?.dependents ?? [])
    .concat(data?.personalInfo?.emergencyContacts ?? [])
    .concat(data?.personalInfo?.beneficiaries ?? []);

  const [filteredData, setFilteredData] = useState<IDependent[]>(removeDuplicatedDependentsById(list));

  const handleSelection = ({ selectedRows }: { selectedRows: IDependent[] }) => {
    setSelectedBeneficiaries(selectedRows);
  };

  const handleLifeBenefits = () => {
    const isLifeBenefit = lifeBenefits.includes(benefit.benefitId);

    let newFilteredData = filteredData;
    if (isLifeBenefit) {
      const selfAsDependent: unknown = { ...data.personalInfo };
      const { dependents } = benefit.settings?.data as DependentsSettings;
      const dependentsIds = dependents?.map(item => item.personId) || [];

      if (benefit.dependents === 'EE+SP') {
        newFilteredData = newFilteredData.filter(item => item.relationship !== 'Spouse');
      }

      if (dependentsIds.length) {
        newFilteredData = newFilteredData.filter(item => !dependentsIds.includes(item.personId as string));
      }

      if (benefit.dependents !== 'EE') {
        const selfDependent = selfAsDependent as IDependent;
        const selfKey =
          (selfDependent.personId as string) ||
          (selfDependent.id as string) ||
          `${selfDependent.firstName || ''}-${selfDependent.relationship || ''}-${selfDependent.ssn || ''}-${
            selfDependent.birthDate || ''
          }`;
        const alreadyExists = newFilteredData.some(item => {
          const itemKey =
            (item.personId as string) ||
            (item.id as string) ||
            `${item.firstName || ''}-${item.relationship || ''}-${item.ssn || ''}-${item.birthDate || ''}`;
          return itemKey === selfKey;
        });

        if (!alreadyExists) {
          newFilteredData.push(selfDependent);
        }
      }

      setFilteredData(removeDuplicatedDependentsById(newFilteredData));
    }
  };

  useEffect(() => {
    handleLifeBenefits();
  }, []);

  const submit = (values: { personId: string; percentToPay: number; name: string }[]) => {
    onSubmit({
      ...benefit,
      settings: {
        rates: benefit.settings?.rates,
        type: benefit.settings?.type ? benefit.settings?.type : BenefitSettingsType.LIFE_INSURANCE,
        data: { ...benefit.settings?.data, beneficiaries: values },
      },
    });
  };

  const nextStep = () => setModalState('FINISH');

  useEffect(() => {
    setSelectedBeneficiaries(filteredData);
    if (benefit.dependents === 'EE') {
      nextStep();
    }
  }, [benefit.dependents]);

  return (
    <>
      {modalState === 'SELECTION' && (
        <>
          <BeneficiariesListContainer>
            <h4>Select your Beneficiary(ies)</h4>
            <DefaultTable
              columns={columns}
              data={filteredData || []}
              customStyles={customStyles}
              selectableRows
              onSelectedRowsChange={handleSelection}
            />
          </BeneficiariesListContainer>
          <BeneficiariesListFooter>
            {onRequestBack && <RegularButton onClick={onRequestBack}>{t('global.button.back')}</RegularButton>}
            <BeneficiariesListRightBottom>
              {onRequestNewBeneficiarie && (
                <RegularButton onClick={onRequestNewBeneficiarie}>{t('benefits.beneficiaries.title')}</RegularButton>
              )}
              <RegularButton disabled={!selectedBeneficiaries.length} onClick={nextStep}>
                {t('global.form.continue')}
              </RegularButton>
            </BeneficiariesListRightBottom>
          </BeneficiariesListFooter>
        </>
      )}
      {modalState === 'FINISH' && (
        <BeneficiariesForm
          beneficiaries={selectedBeneficiaries}
          onSubmit={submit}
          onRequestBack={() => setModalState('SELECTION')}
        />
      )}
    </>
  );
};
